import { default as React, useCallback, useContext, useState } from "react";
import supabase from "../services/supabaseClient";
import { captureError } from "../lib/errorReporting";

const CategoriesContext = React.createContext();
const FetchCategoriesContext = React.createContext();
const ResetCategoriesContext = React.createContext();

export function CategoriesProvider({ children }) {
	const [categories, setCategories] = useState([]);

const mapCategoryDefinition = (row) => ({
		categoryName: row.category_name,
		subcategories: Array.isArray(row.subcategories)
			? [...row.subcategories]
			: []
	});

	const fetchCategories = useCallback(async () => {
		const { data, error } = await supabase
			.from("category_definitions_prod")
			.select("category_name, subcategories")
			.order("category_name", { ascending: true });

		if (error) {
			console.error("fetchCategories failed", error);
			captureError(error, { action: "fetchCategories" });
			return;
		}

		const mapped = Array.isArray(data)
			? data.map(mapCategoryDefinition)
			: [];
		setCategories(mapped);
	}, []);

	const refreshSearch = useCallback(() => {
		setCategories([]);
		fetchCategories();
	}, [fetchCategories]);

	return (
		<FetchCategoriesContext.Provider value={fetchCategories}>
			<ResetCategoriesContext.Provider value={refreshSearch}>
				<CategoriesContext.Provider value={categories}>
					{children}
				</CategoriesContext.Provider>
			</ResetCategoriesContext.Provider>
		</FetchCategoriesContext.Provider>
	);
}

export const useCategories = () => useContext(CategoriesContext);
export const useFetchCategories = () =>
	useContext(FetchCategoriesContext);
export const useResetSearch = () =>
	useContext(ResetCategoriesContext);
